module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "overlay"
  }, [_h('div', {
    staticClass: "overlay-content"
  }, [_h('a', {
    staticClass: "overlay-close",
    attrs: {
      "href": ""
    },
    on: {
      "click": back
    }
  }, ["✕"]), " ", _m(0)])])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "overlay-inner"
  }, [_h('div', {
    staticClass: "cleanmap"
  }, [_h('h2', ["Cleantech Startup Map"]), " ", _h('p', ["The Cleantech Startup Map will soon be available."])])])
}}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e712297e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Map.vue
// module id = 41
// module chunks = 1